module.exports = __webpack_public_path__ + "static/assets/d11f933570ff0cb8c71e25aed760f609.gif";